import { api, type ApiEnvelope } from '../../services/api';
import type { AdminNotification } from '../types';

export const adminNotificationsService = {
  async list(unreadOnly = false) {
    const { data } = await api.get<ApiEnvelope<{ items: AdminNotification[] }>>('/admin/notifications', {
      params: unreadOnly ? { unreadOnly: true } : undefined,
    });
    return data.data.items;
  },
  async markRead(id: string) {
    await api.patch(`/admin/notifications/${id}/read`);
  },
};
